import { useEffect, useState, useRef } from "react";
import { Col, Container, Form, Modal, Row } from "react-bootstrap";
import "./inspection.css";
import { postRequest, getRequest } from "../../../actions/Handler";
import { Calendar } from "primereact/calendar";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
// import { Toast } from "primereact/toast";
import { toast } from "react-toastify";

import { json } from "stream/consumers";
import moment from "moment";

const errorInitial = {
  inspectionCompletedOn: "",
  isSecondaryReviewRequested: "",
  inspectionComment: "",
  riskReviewStatus:""
};

const inuputInitialValues = {
  inspectionCompletedOn: undefined,
  isSecondaryReviewRequested: undefined,
  inspectionComment: "",
  sharedCommentaryText: "",
  riskReviewStatus:"Not Requested"
};

export default function InspectionModel(props: any) {
  const [saveLoader, setSaveLoader] = useState(false);
  const { show, toggleShow, completionDetails,eventReportId, viewOnly, eventTitle } = props;
  let today = new Date();

  const initialInputValues = {
    inspectionCompletedOn: undefined,
    isSecondaryReviewRequested: undefined,
    inspectionComment: "",
    sharedCommentaryText: "",
    riskReviewStatus:""
  };

  let userDetail = JSON.parse(
    sessionStorage.getItem("userDetail") || "{}"
  ) as any;

  let isCentralUser: boolean = false;
 
  if (userDetail.role === "Central User") {
    isCentralUser = true;
  }

  const [inputValues, setInputValue] = useState<any>(inuputInitialValues);

  const [errorValues, setErrorValue] = useState(errorInitial);
  // const toast = useRef<Toast>(null);

  useEffect(() => {
    if (show) {
      if(viewOnly){
        setInputValue(completionDetails);
      }
      else{
        setInputValue(inuputInitialValues);
      }
      document.body.style.overflow = "hidden !important";
    } else {
      document.body.style.overflow = "visible";
    }
    return () => {
      setErrorValue(errorInitial);
      setInputValue(inuputInitialValues);
    };
  }, [show]);


  if (show) {
    const handleFormChange = (event: any) => {
      let formValue;
      if (event.target.name === "isSecondaryReviewRequested") {
        let formParams = { ...inputValues } as any;
        formValue = event.target.value === "0" ? false : true;
        if (formValue === formParams[event.target.name]) {
          event.target.value = undefined;
          formValue = undefined;
        }
      }
      
      else {
        formValue = event.target.value;
      }

      inputValueSet(event.target.name, formValue);

      //Validation
      let error = { ...errorValues };
      if (event.target.name === "inspectionCompletedOn") {
        if (formValue == null) {
          error.inspectionCompletedOn = "Inspection Completed Date is required";
        } else error.inspectionCompletedOn = "";
      } else if (event.target.name === "isSecondaryReviewRequested") {
        if (formValue == null)
          error.isSecondaryReviewRequested =
            "Secondary Review Requested is required";
        else error.isSecondaryReviewRequested = "";
      } else if (event.target.name === "inspectionComment") {
        if (event.target.value.length > 4000) {
          error.inspectionComment = "Must enter less than 4000 characters!";
        } else {
          error.inspectionComment = "";
        }
      }
      setErrorValue(error);
    };

    const inputValueSet = (name: any, value: any) => {
      let formParams = { ...inputValues } as any;
      formParams[name] = value;
      setInputValue(formParams);
    };

    const mess = () => {
      // toast.current?.show({
      //   severity: "success",
      //   summary: "Success",
      //   detail: "Inspection completed successfully",
      // });
      toast("Inspection completed successfully", {
        type: "success",
        autoClose: 2000,
        pauseOnHover: true,
        delay: 0,
      });
    };
    const errormess = () => {
      // toast.current?.show({
      //   severity: "error",
      //   summary: "Error!",
      //   detail: "Something wrong happened!",
      // });
      toast("Something went wrong!", {
        type: "error",
        autoClose: 2000,
        pauseOnHover: true,
        delay: 0,
      });
    };

    const GetMaxDate = () => {
      var dt = new Date();
      // dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000);
      // var offset = -240; //Timezone offset for EST in minutes.
      // var estDate = new Date(dt.getTime() + offset * 60 * 1000);
      return dt;
    };

    const inspectionSave = async () => {
      let error = { ...errorValues };
      let formValid = true;
      var utcDate = "";
      if (inputValues.inspectionCompletedOn === undefined) {
        error.inspectionCompletedOn = "Inspection Completed Date is required";
        formValid = false;
      }

      if (inputValues.isSecondaryReviewRequested === undefined) {
        error.isSecondaryReviewRequested =
          "Secondary Review Requested is required";
        formValid = false;
      }
      if (inputValues.inspectionComment.length > 4000) {
        error.inspectionComment = "Must enter less than 4000 characters!";
        formValid = false;
      }
      if (inputValues.inspectionCompletedOn !== undefined) {
        if (isFutureDate(inputValues.inspectionCompletedOn)) {
          error.inspectionCompletedOn =
            "Inspection Completed On cannot be a future date!";
          formValid = false;
        }
        var eventDate = new Date(inputValues.inspectionCompletedOn);
        utcDate = eventDate.toISOString();
      }
      setErrorValue(error);
      if (formValid) {
        var inspectionData = {
          eventReportId: eventReportId,          
          ...inputValues,
        };
        inspectionData.sharedCommentary=inputValues.sharedCommentaryText
        inspectionData.inspectionCompletedOn = utcDate;
        inspectionData.siteName=completionDetails?.siteName
        inspectionData.riskReviewStatus=inputValues.riskReviewStatus
        if (formValid) {
          setSaveLoader(true);
        } else {
          setSaveLoader(false);
        }
        postRequest({
          url: "api/EventReportInspection/Create",
          data: inspectionData,
        }).then((res) => {
          mess();
          setTimeout(() => {
            setSaveLoader(false);
            toggleShow();
          }, 1000);
          props.onExit();
          props.setReloadCardVal();
        })
          .catch(
            (e: any) => {
              console.log(e);
              errormess();
              setSaveLoader(false);
            }
          )
      }
    };
    const SetDateToLocale = (dt: Date) => {
      var newDate = new Date(dt.getTime() - dt.getTimezoneOffset() * 60 * 1000);
      return newDate;
    }
    const isFutureDate = (idate: Date) => {
      var today = new Date();
      return today > idate ? false : true;
    };
    const formattedDate = (date: any) => {
      var formattedDate = new Date(date);
      var month = formattedDate.getMonth();
      var day = formattedDate.getDay();
      var year = formattedDate.getFullYear();
      var dateString: string = `${month}/${day}/${year}`;
      return dateString;
    };
    return (
      <>
        {saveLoader ? (
          <>
            <div id="q11">
              <div className="loading">
                <div className="obj"></div>
              </div>
            </div>{" "}
          </>
        ) : null}
        {/* <Toast ref={toast}></Toast> */}
        <Modal
          show={show}
          onHide={toggleShow}
          backdrop="static"
          size="lg"
          keyboard={false}
          enforceFocus={true}
          scrollable={true}
        >
          <Modal.Header closeButton style={{ paddingBottom: "0px", paddingLeft: "20px" }}>
            <Modal.Title
              style={{
                color: "#495057",
                fontSize: "15px",
                fontWeight: "600",
              }}
            >
              Inspection
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ paddingBottom: "3px", paddingTop: "0px", paddingLeft: "10px" }}>
            <form
              className="inspection-form"
            //onSubmit={formik.handleSubmit}
            >
              <Container fluid={true}>
                <Col md="12" sm="12" xs="12">
                  <Form.Group
                    className="mb-3"
                    controlId="formCompletionDetails"
                  >
                    <Form.Label className="form-control-header">
                      Completion Details
                    </Form.Label>
                    <div
                      key="inline-details"
                      className="mb-3 completion-details"
                    >
                      <Form.Label className="form-details">
                        {eventTitle}
                      </Form.Label>
                    </div>
                  </Form.Group>
                </Col>
                <Row className="mb-1 " md="4" sm="12" xs="12">
                  <Col xs="12" md="4" sm="12">
                    <Form.Group
                      as={Col}
                      className="inspection-control"
                      controlId="formInspectionCompleted"
                    >
                      <Form.Label className="form-control-header">
                        Inspection Completed On &nbsp;
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <div key="inline-date" className="mb-3">
                        <Calendar
                          readOnlyInput
                          value={
                            inputValues.inspectionCompletedOn
                              ? inputValues.inspectionCompletedOn
                              : undefined
                          }
                          onChange={handleFormChange}
                          className="calender-custom"
                          showTime
                          hourFormat="12"
                          disabled={viewOnly}
                          viewDate={GetMaxDate()}
                          maxDate={GetMaxDate()}
                          showIcon
                          name="inspectionCompletedOn"
                          hideOnDateTimeSelect={true}
                          dateFormat="mm/dd/yy"
                          style={{ width: "100%" }}
                        />
                        <p className="err-text">
                          {errorValues.inspectionCompletedOn}
                        </p>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={4} sm={6}>
                    <Form.Group
                      as={Col}
                      className="inspection-control secondary-review"
                      controlId="formSecondaryReviewRequested"
                    >
                      <Form.Label className="form-control-header">
                        Secondary Review Requested&nbsp;
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <div key="inline-radio" className={"mb-3  mt-1"}>
                        {viewOnly ? (
                          <>
                            <Form.Check
                              inline
                              type="radio"
                              label="&nbsp;&nbsp;Yes"
                              name="isSecondaryReviewRequested"
                              value="1"
                              disabled={true}
                              defaultChecked={
                                inputValues.isSecondaryReviewRequested !==
                                  undefined
                                  ? inputValues.isSecondaryReviewRequested
                                    ? true
                                    : false
                                  : undefined
                              }
                            />
                            <Form.Check
                              inline
                              type="radio"
                              label="&nbsp;&nbsp;No"
                              name="isSecondaryReviewRequested"
                              value="0"
                              disabled={true}
                              defaultChecked={
                                inputValues.isSecondaryReviewRequested !==
                                  undefined
                                  ? !inputValues.isSecondaryReviewRequested
                                    ? true
                                    : false
                                  : undefined
                              }
                            />
                          </>
                        ) : (
                          <>
                            <Form.Check
                              inline
                              type="radio"
                              label="&nbsp;&nbsp;Yes"
                              name="isSecondaryReviewRequested"
                              value="1"
                              onClick={handleFormChange}
                              checked={
                                inputValues.isSecondaryReviewRequested !==
                                  undefined
                                  ? inputValues.isSecondaryReviewRequested
                                    ? true
                                    : false
                                  : undefined
                              }
                            />
                            <Form.Check
                              inline
                              type="radio"
                              label="&nbsp;&nbsp;No"
                              name="isSecondaryReviewRequested"
                              value="0"
                              onClick={handleFormChange}
                              checked={
                                inputValues.isSecondaryReviewRequested !==
                                  undefined
                                  ? !inputValues.isSecondaryReviewRequested
                                    ? true
                                    : false
                                  : undefined
                              }
                            />
                            <p className="err-text">
                              {errorValues.isSecondaryReviewRequested}
                            </p>
                          </>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                  {isCentralUser && 
                  
                  <Col xs={12} md={4} sm={6}>
                    <Form.Group
                      as={Col}
                      className="inspection-control secondary-review"
                      controlId="formSecondaryReviewRequested"
                    >
                      <Form.Label className="form-control-header">
                      Risk Review Status&nbsp;
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <div key="inline-radio" className={"mb-3  mt-1"}>
                        <Form.Check
                              inline
                              type="radio"
                              label="&nbsp;&nbsp;Requested"
                              name="riskReviewStatus"
                              value="Requested"         
                              onClick={handleFormChange}                     
                              checked={
                                inputValues.riskReviewStatus !==
                                  undefined
                                  ? inputValues.riskReviewStatus=="Requested"
                                    ? true
                                    : false
                                  : undefined
                              }
                            />
                            <Form.Check
                              inline
                              type="radio"
                              label="&nbsp;&nbsp;Not Requested"
                              name="riskReviewStatus"
                              value="Not Requested"         
                              onClick={handleFormChange}                     
                              checked={
                                inputValues.riskReviewStatus !==
                                  undefined
                                  ? inputValues.riskReviewStatus=="Not Requested"
                                    ? true
                                    : false
                                  : undefined
                              }
                            />
                            <Form.Check
                              inline
                              type="radio"
                              label="&nbsp;&nbsp;Completed"
                              name="riskReviewStatus"
                              value="Completed"       
                              onClick={handleFormChange}                       
                              checked={
                                inputValues.riskReviewStatus !==
                                  undefined
                                  ? inputValues.riskReviewStatus=="Completed"
                                    ? true
                                    : false
                                  : undefined
                              }
                            />
                      </div>
                    </Form.Group>
                  </Col>
                  }
                  
                </Row>

                <Col md="12" sm="12" xs="12">
                  <Form.Group className="comment-control">
                    <Form.Label className="form-control-header">
                      Comments
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      className={"comment-text"}
                      rows={6}
                      name="inspectionComment"
                      value={inputValues.inspectionComment}
                      onChange={handleFormChange}
                      disabled={viewOnly}
                    />
                    <p className="err-text">{errorValues.inspectionComment}</p>
                  </Form.Group>
                </Col>
                {viewOnly ?
                  <Container
                    fluid={true}
                    className="d-flex flex-row mt-2 p-0"
                  >
                    <Col xs="12" sm="12" md="12">
                      Inspection Completed By:

                      <label className="LightText" style={{ paddingLeft: "2.5rem" }}>
                        {inputValues.inspectionCompletedBy}
                      </label>
                    </Col>
                  </Container> : null}

                <Col md="12" sm="12" xs="12" className="pb-0">

                  <label>
                    Shared Commentary
                  </label>
                  <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Control
                      as="textarea"
                      rows={6}
                      name="sharedCommentaryText"
                      value={inputValues.sharedCommentaryText}
                      onChange={handleFormChange}
                      //disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>
                {
                        inputValues?.sharedCommentary?
                        <Col xs="12" sm="12" md="12">
                        Last saved by: <span className="LightText">{inputValues?.sharedCommentary?.commentedByUser+" "+moment(inputValues?.sharedCommentary?.commentedOn).local().format("MM/DD/YYYY hh:mm A")}</span>
                      </Col>
                      :<></>
                      }
              </Container>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="buttonCss" onClick={toggleShow}>
              Cancel
            </button>
            <button
              className="buttonCss"
              //disabled={viewOnly}
              onClick={inspectionSave}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  } else {
    return <></>;
  }
}
